import axios from "axios";
import { useDispatch } from "react-redux";
import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from "src/utils/helper";
import { logOutAction } from "./auth";
import { store } from "src/store";
import { showToast } from "src/customHooks/ToastEmitter";


export const API_URLS = { 
    baseURL: window._env_?.REACT_APP_BASE_URL_MAIN_VAYU || process.env.REACT_APP_BASE_URL_MAIN_VAYU,
   //baseURL: process.env.REACT_APP_BASE_URL_MAIN_VAYU,

};
 
export const api = (baseURL) => {
  return axios.create({
    baseURL,
  });
};


export const instance = axios.create({ baseURL:API_URLS.baseURL });
let isRefreshing = false;
let refreshSubscribers = [];
const handleConfig = async (config: any) => {
  const token = await getLocalStorage("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  // if (config.data instanceof FormData) {
  //   config.headers["Content-Type"] = "multipart/form-data";
  // } else {
    config.headers["Content-Type"] = "application/json";
  // }
  return config;
};

const logoutUser = () => {
  // @ts-ignore
  store.dispatch(
    logOutAction({
      // @ts-ignore
      userId: decodeAccessToken()?.UserId,
    })
  );
  clearLocalStorage();
  window.location.replace("/login");
};

const setupInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => handleConfig(config),
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.code === "ERR_NETWORK") {
        showToast(error?.message || "Network error occurred", {
          appearance: "error",
        });
        return;
      }

      const errorData = error?.response?.data;

      if (typeof errorData === "string" && errorData.includes("expired")) {
        logoutUser();
        return;
      }

      let login;
      const url = error?.response?.config?.url;
      if (url) {
        const splitUrl = url?.split("/");
        login = splitUrl[splitUrl?.length - 1].toLowerCase();
      }
      if (login !== "login") {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
          if (isRefreshing) {
            return new Promise((resolve) => {
              refreshSubscribers.push((token) => {
                originalRequest.headers["Authorization"] = `Bearer ${token}`;
                resolve(axios(originalRequest));
              });
            });
          }
          originalRequest._retry = true;
          isRefreshing = true;
          return new Promise((resolve, reject) => {
            const access_token = getLocalStorage("accessToken");
            axios
              .post(`${API_URLS.baseURL}/Authentication/Login`, {
                grantType: "refresh_token",
                refreshToken: access_token,
              })
              .then((response) => {
                const res = response.data;
                setLocalStorage("accessToken", res.accessToken);
                setLocalStorage("isApiUser", res.isApiUser);
                setLocalStorage("isAuthenticated", res.isAuthenticated);
                originalRequest.headers[
                  "Authorization"
                ] = `Bearer ${res.accessToken}`;
                resolve(axios(originalRequest));
                refreshSubscribers.forEach((callback) =>
                  callback(res.accessToken)
                );
              })
              .catch((err) => {
                logoutUser();
                // clearLocalStorage();
                // window.location.replace('/login');
                reject(err);
              })
              .finally(() => {
                isRefreshing = false;
                refreshSubscribers = [];
              });
          });
        }
      }
      if (error?.response?.status === 500 || error?.response?.status === 502) {
        showToast("Something went wrong!", { appearance: "error" });
        //  return Promise.reject(error?.response || 'Something went wrong!');
      } else if (error?.response?.status === 404) {
        showToast("Something went wrong!", { appearance: "error" });
      } else {
        return Promise.reject(error.response || "Something went wrong!");
      }
    }
  );
};

setupInterceptors(instance);

export default instance;
